module.exports = __webpack_public_path__ + "files/db305601519dd00527deca992ffd2b65.png";